import {
  SET_AUTH_TOKEN
  SET_USER_ACLS
  SET_USER_MODE
  SET_USER_ROLES
  SET_IS_MONTEUR
} from './actionTypes'

export setAuthToken = (authToken) ->
  type: SET_AUTH_TOKEN
  payload: { authToken }

export setUserAcls = (data) ->
  type: SET_USER_ACLS
  payload: { data }

export setUserMode = (data) ->
  type: SET_USER_MODE
  payload: { data }

export setUserRoles = (data) ->
  type: SET_USER_ROLES
  payload: { data }

export setIsMonteur = (data) ->
  type: SET_IS_MONTEUR
  payload: { data }
